import * as React from 'react';
import { TabStyles } from '../styles/TabStyles';
import { makeTestId } from '../utils/Declarative';
import { EventUtilsOptOut } from '../utils/ReactHelpers';
import { StackingComponentHOC, StackingComponentProps } from '../utils/StackingComponent';

const getStyles: () => {
  Glass: React.CSSProperties,
  Clear: React.CSSProperties,
  Opaque: React.CSSProperties
} = () => {
  return {
    Glass: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      padding: 0,
      margin: 0,
      pointerEvents: 'auto'
    },

    Clear: {
      backgroundColor: TabStyles.Colors.White,
      opacity: TabStyles.Opacity.ClearGlass
    },

    Opaque: {
      backgroundColor: TabStyles.Colors.OpaqueGlass,
      opacity: TabStyles.Opacity.OpaqueGlass
    }
  };
};

export interface GlassProps extends StackingComponentProps {
  testId: string;
  isTransparent?: boolean;
  handleClick?: () => void;
  handleEscape?: () => void;
}

export class GlassWidgetBase extends React.Component<GlassProps> {
  private handleClick: React.MouseEventHandler<HTMLDivElement> = e => {
    e.preventDefault();
    this.props.handleClick?.();
  }

  private handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if ((e.key === 'Tab' && e.shiftKey) ||
      (e.key === 'Escape' && this.props.handleEscape)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  private handleKeyUp = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (this.props.handleEscape && e.key === 'Escape') {
      this.props.handleEscape();
      e.preventDefault();
      e.stopPropagation();
    }
  }

  public render(): JSX.Element {
    const styles = getStyles();
    const style = { ...styles.Glass, ...(this.props.isTransparent ? styles.Clear : styles.Opaque) };

    return (
      <div
        {...EventUtilsOptOut}
        data-tb-test-id={makeTestId(this.props.testId, 'Glass')}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        onKeyUp={this.handleKeyUp}
        style={style}
        tabIndex={0}
      />
    );
  }
}

export const GlassWidget = StackingComponentHOC(GlassWidgetBase);
GlassWidget.displayName = 'GlassWidget';
